<template>
    <pop>
        <div class="head-line"></div>
        <div v-show="step == 1" class="content-box">
            <p class="title">合格投资者认定</p>
            <p
                class="content"
            >根据《私募投资基金募集行为管理办法》之规定，博牛投资网只对“具有相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元，且个人金融类资产不低于300万元或者最近三年个人年均收入不低于50万元”的特定投资者宣传、推介相关私募投资基金产品。</p>
            <p
                class="content"
            >根据2018年4月27日发布的《关于规范金融机构资产管理业务的指导意见》，您需进行认证，才能浏览相关私募信息（如您之前已完成认证，根据新规需重新认证）。</p>
            <div class="align-left" v-show="!hasAuthId">
                <check-box :isChecked.sync="state" id="readed">
                    <p>我已阅读并接受此认定书</p>
                </check-box>
            </div>
            <p class="align-center" v-show="hasAuthId">您尚未完成调查问卷</p>
            <div class="btn" @click="runType">{{btnStr}}</div>
        </div>
        <div v-show="step == 2" class="content-box">
            <p class="tel">{{tel}}</p>
            <p class="prompt">为了更好的维护您的投资权益，以及为您提供优质投资方案，请您尽快完成身份认证和风险测评</p>
            <input type="text" placeholder="请输入您的真实姓名" v-model="name" />
            <input type="text" placeholder="请输入18位身份证号" v-model="idCard" />
            <div class="align-left">
                <check-box :isChecked.sync="state" id="statement">
                    <p>我声明为中国税收居民</p>
                </check-box>
            </div>
            <div class="btn" @click="auth">提交认证</div>
        </div>
    </pop>
</template>

<script>
import {post} from '@/http.js'
export default {
    components: {
        pop: () => import("./base-pop.vue"),
        checkBox: () => import("../tool/check-box.vue")
    },
    data() {
        return {
            name: "",
            idCard: "",
            state: true,
            step: 1,
            hasAuthId: false,
            btnStr: '立即认证'
        };
    },
    computed: {
        tel() {
            return this.$store.state.login_phone;
        }
    },
    methods: {
        auth() {
            var idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
            if(idcardReg.test(this.idCard)) {
                post('user/update_id', {
                    id: this.idCard,
                    name: this.name,
                    mobile: this.tel
                }).then(() => {
                    this.$root.$emit('closePop')
                    this.$router.push('/evaluation')
                }, err => {
                    if(err == 100) {
                        this.$root.$emit('login')
                    } 
                })
            } else {
                alert('身份证格式错误');
            }
            
        },
        runType() {
            post('user/assessment_query')
                .then(res => {
                    if(!res[0].id_no || res[0].id_no.substr(0, 4) == "fake") {
                        this.step = 2
                    } else if(!res[0].assessment.date) {
                        this.$root.$emit('closePop')
                        this.$router.push('/evaluation')
                    } else {
                        this.$store.commit('getScore', res[0].assessment.score)
                        this.$store.commit('changePop', false)
                    }
                })
        }
    },
    mounted() {
        post('user/assessment_query')
        .then(res => {
            if(res[0].id_no && res[0].id_no.substr(0, 4) != "fake") {
                this.hasAuthId = true
                this.btnStr = '进行调查问卷'
            }
        })
    },
};
</script>

<style lang="scss" scoped>
p {
    margin: 0;
}
.head-line {
    margin-top: 29px;
    height: 3px;
    background: linear-gradient(to right, #333333 50%, #427fdc 50%);
}
.content-box {
    width: 454px;
    margin: auto;
}
.tel {
    margin-top: 29px;
    color: #333333;
    font-size: 18px;
}
.prompt {
    margin-top: 30px;
    color: #9c9c9c;
    font-size: 15px;
}
input {
    font-size: 18px;
    display: block;
    width: 100%;
    height: 54px;
    margin-top: 30px;
    padding-left: 12px;
    box-sizing: border-box;
}
.align-left {
    text-align: left;
    p {
        color: #022f72;
        margin-left: 33px;
    }
}
.align-center {
    color: #CB4646;
    font-size: 18px;
    margin: 31px;
}
.btn {
    line-height: 54px;
    background: #022f72;
    color: #ffffff;
    font-size: 22px;
    border-radius: 10px;
}
.title {
    color: #333333;
    font-size: 20px;
    margin-top: 30px;
    margin-bottom: 27px;
    font-weight: bold;
}
.content {
    text-align: left;
    color: #333333;
    font-size: 18px;
}
</style>